import articleWispehone from "./work-articles/articleWisephone";
import articleTechAddictionQuiz from "./work-articles/articleTechAddictionQuiz";
import articleSignatureBuilder from "./work-articles/articleSignatureBuilder";
import articleKirkElliott from "./work-articles/articleKirkElliott";

const work_dev = [
  articleKirkElliott,
  articleWispehone,
  articleTechAddictionQuiz,
  articleSignatureBuilder
]
export default work_dev;